module.exports = __webpack_public_path__ + "img/n27.fb94ef32.png";